import httpClient from "./http";

export const getStoreJourneyConfig = (storeId: string) =>
  httpClient.get(`/api/stores/journey/${storeId}`);

export const getStoreChatConfig = (storeId: string) =>
  httpClient.get(`/api/stores/chat/${storeId}`);
